<!--两行问题(提示语+问题)-->
<template>
    <div class="message-template clearfix">
        <div class="person-icon"></div>
            <div class="message-container">
                <div class="triangle"></div>
                <div class="message">
                    <div class="message-header">您是否想咨询以下问题？</div>
                    <div class="split-line"></div>
                    <div class="message-body">
                    <ul>
                    <li v-for="item in content">
                        <a href="javascript:void(0);" @click="querySelected(item.title)">{{item.title}}</a>
                    </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        data() {
            return {

            }
        },
        props: {
            content: {
                type: Array
            }
        },
        methods: {
            querySelected(msg) {
                this.$dispatch('user-message', Object({message: msg, source: 'user', click: true}));
            }
        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// ManyIssues.vue?0a3d535f